import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { Container, Row, Col, Form as BootstrapForm } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { BsArrowLeftCircleFill } from 'react-icons/bs';
import {
  updatePatientAction,
  getpatientDetailsById,
} from "../../Action/modernAdminActions";
import { editPatientSchema } from '../../validations/patientSchema';
import { showLoading, dismissLoading, showSuccess, showError } from '../../utils/validationHelper';
import { parsePydanticValidationErrors } from '../../utils/errorHandler';
import { safeErrorRender } from '../../lib/utils/safeErrorRender';
import config from '../../config/config';
import Dashboardheader from './dashboardheader';
import Sidebar from './sidebar';
import { Toaster } from 'react-hot-toast';
import Select from 'react-select';
import { LANGUAGE_OPTIONS } from '../../constants/languageOptions';
import { UAE_STATE_OPTIONS } from '../../constants/uaeStates';
import "../componentCss/webform.css";
import "../componentCss/sidebar.css";

// Common country codes for mobile numbers
const COUNTRY_CODES = [
  { code: "+971", country: "🇦🇪 UAE", flag: "🇦🇪" },
  { code: "+1", country: "🇺🇸 USA", flag: "🇺🇸" },
  { code: "+44", country: "🇬🇧 UK", flag: "🇬🇧" },
  { code: "+91", country: "🇮🇳 India", flag: "🇮🇳" },
  { code: "+92", country: "🇵🇰 Pakistan", flag: "🇵🇰" },
  { code: "+880", country: "🇧🇩 Bangladesh", flag: "🇧🇩" },
  { code: "+63", country: "🇵🇭 Philippines", flag: "🇵🇭" },
  { code: "+20", country: "🇪🇬 Egypt", flag: "🇪🇬" },
  { code: "+962", country: "🇯🇴 Jordan", flag: "🇯🇴" },
  { code: "+961", country: "🇱🇧 Lebanon", flag: "🇱🇧" },
  { code: "+966", country: "🇸🇦 Saudi Arabia", flag: "🇸🇦" },
  { code: "+968", country: "🇴🇲 Oman", flag: "🇴🇲" },
  { code: "+973", country: "🇧🇭 Bahrain", flag: "🇧🇭" },
  { code: "+974", country: "🇶🇦 Qatar", flag: "🇶🇦" },
  { code: "+965", country: "🇰🇼 Kuwait", flag: "🇰🇼" },
  { code: "+60", country: "🇲🇾 Malaysia", flag: "🇲🇾" },
  { code: "+65", country: "🇸🇬 Singapore", flag: "🇸🇬" },
  { code: "+66", country: "🇹🇭 Thailand", flag: "🇹🇭" },
  { code: "+84", country: "🇻🇳 Vietnam", flag: "🇻🇳" },
  { code: "+86", country: "🇨🇳 China", flag: "🇨🇳" },
  { code: "+81", country: "🇯🇵 Japan", flag: "🇯🇵" },
  { code: "+82", country: "🇰🇷 South Korea", flag: "🇰🇷" },
  { code: "+61", country: "🇦🇺 Australia", flag: "🇦🇺" },
  { code: "+64", country: "🇳🇿 New Zealand", flag: "🇳🇿" },
  { code: "+49", country: "🇩🇪 Germany", flag: "🇩🇪" },
  { code: "+33", country: "🇫🇷 France", flag: "🇫🇷" },
  { code: "+39", country: "🇮🇹 Italy", flag: "🇮🇹" },
  { code: "+34", country: "🇪🇸 Spain", flag: "🇪🇸" },
  { code: "+31", country: "🇳🇱 Netherlands", flag: "🇳🇱" },
  { code: "+41", country: "🇨🇭 Switzerland", flag: "🇨🇭" },
  { code: "+46", country: "🇸🇪 Sweden", flag: "🇸🇪" },
  { code: "+47", country: "🇳🇴 Norway", flag: "🇳🇴" },
  { code: "+45", country: "🇩🇰 Denmark", flag: "🇩🇰" },
  { code: "+7", country: "🇷🇺 Russia", flag: "🇷🇺" },
  { code: "+55", country: "🇧🇷 Brazil", flag: "🇧🇷" },
  { code: "+54", country: "🇦🇷 Argentina", flag: "🇦🇷" },
  { code: "+52", country: "🇲🇽 Mexico", flag: "🇲🇽" },
  { code: "+27", country: "🇿🇦 South Africa", flag: "🇿🇦" },
];

// Religion options with codes and labels
const RELIGION_OPTIONS = [
  { code: "BUD", label: "Buddhist" },
  { code: "BMA", label: "Buddhist: Mahayana" },
  { code: "BTH", label: "Buddhist: Theravada" },
  { code: "CHR", label: "Christian" },
  { code: "ANG", label: "Christian: Anglican" },
  { code: "BAP", label: "Christian: Baptist" },
  { code: "CHS", label: "Christian: Christian Science" },
  { code: "NAZ", label: "Christian: Church of the Nazarene" },
  { code: "EPI", label: "Christian: Episcopalian" },
  { code: "GRE", label: "Christian: Greek Orthodox" },
  { code: "JWN", label: "Christian: Jehovah's Witness" },
  { code: "LUT", label: "Christian: Lutheran" },
  { code: "MEN", label: "Christian: Mennonite" },
  { code: "MET", label: "Christian: Methodist" },
  { code: "PEN", label: "Christian: Pentecostal" },
  { code: "PRE", label: "Christian: Presbyterian" },
  { code: "PRO", label: "Christian: Protestant" },
  { code: "CAT", label: "Christian: Roman Catholic" },
  { code: "SEV", label: "Christian: Seventh Day Adventist" },
  { code: "UNU", label: "Christian: Unitarian Universalist" },
  { code: "ERL", label: "Ethnic Religionist" },
  { code: "HIN", label: "Hindu" },
  { code: "HOT", label: "Hindu: Other" },
  { code: "JAI", label: "Jain" },
  { code: "JEW", label: "Jewish" },
  { code: "MOS", label: "Muslim" },
  { code: "MOT", label: "Muslim: Other" },
  { code: "MSH", label: "Muslim: Shiite" },
  { code: "MSU", label: "Muslim: Sunni" },
  { code: "OTH", label: "Other" },
  { code: "SHN", label: "Shintoist" },
  { code: "SIK", label: "Sikh" },
  { code: "VAR", label: "Unknown" }
].sort((a, b) => a.label.localeCompare(b.label));

// Valid emergency contact relationships
const VALID_RELATIONSHIPS = [
  'spouse', 'parent', 'child', 'sibling', 'friend', 'colleague',
  'guardian', 'grandparent', 'grandchild', 'aunt', 'uncle', 'cousin',
  'other family', 'caregiver', 'other'
];

// Helper function to format Emirates ID with dashes: 784-1234-5678-901-2
const formatEmiratesId = (value) => {
  if (!value) return '';

  // Remove all non-digit characters
  const digitsOnly = value.replace(/\D/g, '');

  // Limit to 15 digits
  const limited = digitsOnly.slice(0, 15);

  // Format as: 784-XXXX-XXXX-XXX-X
  if (limited.length <= 3) return limited;
  if (limited.length <= 7) return `${limited.slice(0, 3)}-${limited.slice(3)}`;
  if (limited.length <= 11) return `${limited.slice(0, 3)}-${limited.slice(3, 7)}-${limited.slice(7)}`;
  if (limited.length <= 14) return `${limited.slice(0, 3)}-${limited.slice(3, 7)}-${limited.slice(7, 11)}-${limited.slice(11)}`;
  return `${limited.slice(0, 3)}-${limited.slice(3, 7)}-${limited.slice(7, 11)}-${limited.slice(11, 14)}-${limited.slice(14, 15)}`;
};

const EditPatientCredentials = () => {
  const { patientId } = useParams();
  const navigate = useNavigate();
  const [patientDetails, setPatientDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    getPatientDetailsAPI();
  }, []);

  let getPatientDetailsAPI = async () => {
    try {
      console.log('🔍 Searching patient by ID:', patientId);
      let res = await getpatientDetailsById(patientId);
      
      console.log('📥 API Response received:', res);
      
      // Extract patient data from the response structure
      const patientData = res?.data || res;
      
      console.log('👤 Patient data extracted:', patientData);
      
      if (patientData && patientData.id) {
        // Parse phone number to separate country code and number
        const parsePhoneNumber = (fullPhone) => {
          if (!fullPhone) return { countryCode: '+971', phoneNumber: '' };
          
          const phone = fullPhone.toString();
          const countryCode = COUNTRY_CODES.find(cc => phone.startsWith(cc.code));
          
          if (countryCode) {
            return {
              countryCode: countryCode.code,
              phoneNumber: phone.substring(countryCode.code.length)
            };
          }
          
          return { countryCode: '+971', phoneNumber: phone };
        };

        const primaryPhone = parsePhoneNumber(patientData.demographics?.phone_primary || patientData.phone_primary);
        const emergencyPhone = parsePhoneNumber(
          patientData.demographics?.emergency_contacts?.[0]?.phone || 
          patientData.emergency_contacts?.[0]?.phone || 
          patientData.emergency_contact_phone
        );

        setPatientDetails({
          id: patientData.id,
          // Display-only fields
          mrn_temporary: patientData.mrn_temporary || patientData.mrn || '',
          mrn_permanent: patientData.mrn_permanent || '',

          // Personal Information - EMR Required (enhanced mapping for structured response)
          first_name: patientData.demographics?.first_name || patientData.first_name || '',
          last_name: patientData.demographics?.last_name || patientData.last_name || '',
          date_of_birth: patientData.demographics?.date_of_birth
            ? patientData.demographics.date_of_birth.split('T')[0]
            : patientData.date_of_birth
              ? patientData.date_of_birth.split('T')[0]
              : '',
          gender: patientData.demographics?.gender || patientData.gender || '',
          religion: patientData.demographics?.religion || patientData.religion || '',
          race: patientData.demographics?.race || patientData.race || '',
          language: patientData.demographics?.language || patientData.language || '',
          marital_status: patientData.demographics?.marital_status || patientData.marital_status || '',
          nationality: patientData.demographics?.nationality || patientData.nationality || '',
          country: patientData.demographics?.address?.country || patientData.demographics?.country || patientData.country || 'UAE',
          state: patientData.demographics?.address?.state || patientData.demographics?.state || patientData.state || '',
          citizenship: patientData.demographics?.citizenship || patientData.citizenship || '',
          city: patientData.demographics?.address?.city || patientData.demographics?.city || patientData.city || '',

          // Contact Information - EMR Required
          phone_country_code: primaryPhone.countryCode,
          phone_number: primaryPhone.phoneNumber,
          permanent_address: patientData.demographics?.address?.permanent_address || patientData.demographics?.permanent_address || patientData.permanent_address || '',

          // Medical Information - EMR Required + Additional
          allergy: patientData.demographics?.allergy || patientData.allergy || '',
          primary_physician: patientData.demographics?.primary_physician || patientData.primary_physician || '',
          primary_physician_license: patientData.demographics?.primary_physician_license || patientData.primary_physician_license || '',
          
          // Additional Medical fields
          blood_group: patientData.medical_record?.blood_group || patientData.blood_group || 'unknown',
          height: patientData.medical_record?.height || patientData.height || '',
          weight: patientData.medical_record?.weight || patientData.weight || '',

          // Identification - EMR Required
          emirates_id: formatEmiratesId(patientData.emirates_id || patientData.demographics?.emirates_id || ''),
          passport_number: patientData.passport_number || patientData.demographics?.passport_number || '',

          // Optional Fields (note: these may not be in the current API response structure)
          insurance_provider: patientData.medical_record?.insurance_info?.[0]?.provider || patientData.demographics?.insurance_provider || patientData.insurance_provider || '',
          insurance_policy_number: patientData.medical_record?.insurance_info?.[0]?.policy_number || patientData.demographics?.insurance_policy_number || patientData.insurance_policy_number || '',
          insurance_subscriber_name: patientData.medical_record?.insurance_info?.[0]?.subscriber_name || patientData.demographics?.insurance_subscriber_name || patientData.insurance_subscriber_name || '',

          // Emergency Contact - Optional
          emergency_contact_name: patientData.demographics?.emergency_contacts?.[0]?.name || patientData.emergency_contacts?.[0]?.name || patientData.emergency_contact_name || '',
          emergency_contact_country_code: emergencyPhone.countryCode,
          emergency_contact_phone: emergencyPhone.phoneNumber,
          emergency_contact_relationship: patientData.demographics?.emergency_contacts?.[0]?.relationship || patientData.emergency_contacts?.[0]?.relationship || patientData.emergency_contact_relationship || '',

          // Patient Classification Flags
          is_vip: patientData.demographics?.is_vip || patientData.is_vip || false,
          is_tourist: patientData.demographics?.is_tourist || patientData.is_tourist || false
        });
      } else {
        showError(`Patient not found with ID: ${patientId}`);
        console.error(`❌ Patient not found - ID:`, patientId);
      }
    } catch (error) {
      console.error(`💥 Error loading patient details by ID:`, error);
      
      // Provide more specific error messages
      if (error.response?.status === 404) {
        showError(`Patient not found with ID: ${patientId}`);
      } else if (error.response?.status === 403) {
        showError('Access denied. You do not have permission to view this patient.');
      } else if (error.response?.status >= 500) {
        showError('Server error occurred. Please try again later.');
      } else {
        showError(`Failed to load patient details: ${error.message || 'Unknown error'}`);
      }
    } finally {
      setIsLoadingData(false);
    }
  };

  let handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    const loadingToast = showLoading('Updating patient...');
    setIsLoading(true);
    
    try {
      const patientIdToUpdate = patientDetails?.id;
      if (!patientIdToUpdate) {
        showError('Patient ID not found');
        setIsLoading(false);
        return;
      }

      // Transform the form data to match the PatientUpdate schema (matching addPatientCredentials structure)
      const updateData = {
        demographics: {
          // Personal Information - Required
          first_name: values.first_name,
          last_name: values.last_name,
          date_of_birth: values.date_of_birth ? new Date(values.date_of_birth).toISOString() : null,
          gender: values.gender,
          religion: values.religion,
          race: values.race,
          language: values.language,
          marital_status: values.marital_status,
          nationality: values.nationality,
          country: values.country,
          state: values.state,
          citizenship: values.citizenship,
          city: values.city,

          // Contact Information - Required
          phone_primary: values.phone_country_code + values.phone_number,
          permanent_address: values.permanent_address,

          // Medical Information - Required
          allergy: values.allergy,
          primary_physician: values.primary_physician,
          primary_physician_license: values.primary_physician_license,

          // Identification - Required
          emirates_id: values.emirates_id ? values.emirates_id.replace(/[-\s]/g, '') : values.emirates_id,

          // Optional Fields
          passport_number: values.passport_number || null,
          insurance_provider: values.insurance_provider || null,
          insurance_policy_number: values.insurance_policy_number || null,
          insurance_subscriber_name: values.insurance_subscriber_name || null,

          // Emergency Contact - Optional
          emergency_contact_name: values.emergency_contact_name || null,
          emergency_contact_phone: values.emergency_contact_phone ?
            values.emergency_contact_country_code + values.emergency_contact_phone : null,
          emergency_contact_relationship: values.emergency_contact_relationship || null,

          // Patient Classification Flags
          is_vip: values.is_vip || false,
          is_tourist: values.is_tourist || false
        },
        
        // Additional medical fields (outside demographics to match current API structure)
        blood_group: values.blood_group,
        height: values.height ? parseFloat(values.height) : null,
        weight: values.weight ? parseFloat(values.weight) : null,
      };

      const response = await updatePatientAction(patientIdToUpdate, updateData);

      dismissLoading(loadingToast);

      if (response.success || response.id) {
        showSuccess('Patient updated successfully!');
        setTimeout(() => {
          navigate(`${config.baseUrl}patient-records`, {
            state: {
              refresh: true,
              message: 'Patient updated successfully',
              updatedPatientId: patientIdToUpdate
            }
          });
        }, 1500);
      } else {
        showError(response.message || 'Failed to update patient');
      }
    } catch (error) {
      dismissLoading(loadingToast);

      // Handle RBAC/Permission errors (403) explicitly
      const status = error?.response?.status;
      if (status === 403) {
        const permissionMessage = error?.response?.data?.detail ||
          'You do not have permission to update patient information.';
        showError(permissionMessage);
        setIsLoading(false);
        setSubmitting(false);
        return; // Don't process as validation error
      }

      // Parse Pydantic validation errors
      const { hasValidationErrors, fieldErrors, firstError } = parsePydanticValidationErrors(error);

      if (hasValidationErrors) {
        console.log('🔍 Parsed validation errors:', fieldErrors);

        // Set field errors in Formik
        Object.keys(fieldErrors).forEach(field => {
          setFieldError(field, fieldErrors[field]);
        });

        // Show error toast
        showError(`Validation failed: ${firstError.message}`);

        // Auto-scroll to first error field
        if (firstError && firstError.field) {
          setTimeout(() => {
            const fieldElement = document.querySelector(`[name="${firstError.field}"]`);
            if (fieldElement) {
              fieldElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
              fieldElement.focus();
            }
          }, 100);
        }
      } else {
        // Generic error handling for non-validation errors
        const errorMessage = error.response?.data?.error?.message ||
                            error.response?.data?.detail ||
                            error.message ||
                            "Failed to update patient";
        showError(errorMessage);
      }
    } finally {
      setIsLoading(false);
      setSubmitting(false);
    }
  };

  if (isLoadingData) {
    return (
      <>
        <Dashboardheader />
        <Toaster />
        <div className="wrapper">
          <Sidebar />
          <div id="content">
            <Container fluid className="p-4">
              <div className="text-center">
                <img
                  height="50"
                  width="50px"
                  src="assets/images/loading.gif"
                  alt="Loading"
                />
                <p>Loading patient details...</p>
              </div>
            </Container>
          </div>
        </div>
      </>
    );
  }

  if (!patientDetails) {
    return (
      <>
        <Dashboardheader />
        <Toaster />
        <div className="wrapper">
          <Sidebar />
          <div id="content">
            <Container fluid className="p-4">
              <div className="text-center">
                <p>Patient not found</p>
                <Link to={`${config.baseUrl}patient-records`}>
                  <button className="btn btn-primary">Back to Patient List</button>
                </Link>
              </div>
            </Container>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Dashboardheader />
      <Toaster />
      <div className="wrapper">
        <Sidebar />
        <div id="content">
          <Container fluid className="p-4">
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div className="innerhead mb-4">
                  <h5 className="headtitle">Edit Patient Information</h5>
                </div>
                <Link to={`${config.baseUrl}patient-records`}>
                  <span style={{ float: "right" }}>
                    Back <BsArrowLeftCircleFill />
                  </span>
                </Link>
              </Col>
            </Row>
            <Row>
              <Col lg={12} md={12} sm={12} className="">
                <div className="formDiv">
                  <Formik
                    initialValues={patientDetails}
                    validationSchema={editPatientSchema}
                    onSubmit={handleSubmit}
                    validateOnChange={true}
                    validateOnBlur={true}
                    validateOnMount={false}
                    enableReinitialize={true}
                    validateOnSubmit={true}
                  >
                    {({
                      errors,
                      handleSubmit,
                      handleBlur,
                      handleChange,
                      touched,
                      values,
                      setFieldValue,
                      isValid,
                      dirty,
                      isSubmitting,
                      validateForm,
                      setTouched
                    }) => {
                      const handleFormSubmit = async (e) => {
                        // Prevent default form submission to avoid URL parameters
                        e.preventDefault();
                        e.stopPropagation();
                        
                        // Validate form before submission
                        const validationErrors = await validateForm();
                        
                        if (Object.keys(validationErrors).length > 0) {
                          // Mark errored fields as touched so UI shows feedback
                          const touchedErrors = Object.keys(validationErrors).reduce((acc, key) => {
                            acc[key] = true;
                            return acc;
                          }, {});
                          setTouched(touchedErrors, true);

                          // Show first error message to the user
                          const firstError = Object.values(validationErrors)[0];
                          const message = typeof firstError === 'string' && firstError.trim().length > 0
                            ? firstError
                            : 'Please correct the highlighted fields.';
                          showError(message);
                          return;
                        }

                        handleSubmit(e);
                      };

                      return (
                        <Form onSubmit={handleFormSubmit} autoComplete="off" noValidate action="">
                          {/* Patient Information - Display Only */}
                          <h6 className="mb-3">Patient Information</h6>
                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Patient ID</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                value={patientDetails.id}
                                disabled
                                className="bg-light"
                              />
                            </BootstrapForm.Group>
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Temporary MRN</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                value={patientDetails.mrn_temporary || 'N/A'}
                                disabled
                                className="bg-light"
                              />
                            </BootstrapForm.Group>
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Permanent MRN</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                value={patientDetails.mrn_permanent || 'N/A'}
                                disabled
                                className="bg-light"
                              />
                            </BootstrapForm.Group>
                          </Row>

                          {/* Personal Information */}
                          <h6 className="mb-3 mt-4">Personal Information</h6>
                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>First Name *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="first_name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.first_name}
                                placeholder="Enter first name"
                                isInvalid={touched.first_name && errors.first_name}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.first_name)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Last Name *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="last_name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.last_name}
                                placeholder="Enter last name"
                                isInvalid={touched.last_name && errors.last_name}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.last_name)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Religion *</BootstrapForm.Label>
                              <BootstrapForm.Select
                                name="religion"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.religion}
                                isInvalid={touched.religion && errors.religion}
                                required
                              >
                                <option value="">Select religion</option>
                                {RELIGION_OPTIONS.map((religion) => (
                                  <option key={religion.code} value={religion.code}>
                                    {religion.label}
                                  </option>
                                ))}
                              </BootstrapForm.Select>
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.religion)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Date of Birth *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="date"
                                name="date_of_birth"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.date_of_birth}
                                isInvalid={touched.date_of_birth && errors.date_of_birth}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.date_of_birth)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Gender *</BootstrapForm.Label>
                              <BootstrapForm.Select
                                name="gender"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.gender}
                                isInvalid={touched.gender && errors.gender}
                                required
                              >
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                              </BootstrapForm.Select>
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.gender)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Race *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="race"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.race}
                                placeholder="Enter race (e.g., Asian, Caucasian, African)"
                                isInvalid={touched.race && errors.race}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.race)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Language *</BootstrapForm.Label>
                              <Select
                                name="language"
                                options={LANGUAGE_OPTIONS}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                onChange={(selectedOption) => setFieldValue("language", selectedOption?.value || "")}
                                onBlur={handleBlur}
                                value={LANGUAGE_OPTIONS.find(lang => lang.value === values.language) || null}
                                placeholder="Search and select language..."
                                isClearable={false}
                                isSearchable={true}
                                aria-required="true"
                                aria-invalid={touched.language && errors.language ? "true" : "false"}
                              />
                              {touched.language && errors.language && (
                                <div className="text-danger mt-1">
                                  {safeErrorRender(errors.language)}
                                </div>
                              )}
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Marital Status *</BootstrapForm.Label>
                              <BootstrapForm.Select
                                name="marital_status"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.marital_status}
                                isInvalid={touched.marital_status && errors.marital_status}
                                required
                              >
                                <option value="">Select Marital Status</option>
                                <option value="single">Single</option>
                                <option value="married">Married</option>
                                <option value="divorced">Divorced</option>
                                <option value="widowed">Widowed</option>
                                <option value="separated">Separated</option>
                              </BootstrapForm.Select>
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.marital_status)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Nationality *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="nationality"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.nationality}
                                placeholder="Enter nationality"
                                isInvalid={touched.nationality && errors.nationality}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.nationality)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Country of Residence *</BootstrapForm.Label>
                              <BootstrapForm.Select
                                name="country"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.country}
                                isInvalid={touched.country && errors.country}
                                required
                              >
                                <option value="UAE">United Arab Emirates</option>
                                <option value="USA">United States</option>
                                <option value="UK">United Kingdom</option>
                                <option value="Canada">Canada</option>
                                <option value="Australia">Australia</option>
                                <option value="Other">Other</option>
                              </BootstrapForm.Select>
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.country)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>State *</BootstrapForm.Label>
                              <BootstrapForm.Select
                                name="state"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.state}
                                isInvalid={touched.state && errors.state}
                                required
                              >
                                <option value="">Select state or emirate</option>
                                {UAE_STATE_OPTIONS.map((state) => (
                                  <option key={state.value} value={state.value}>
                                    {state.label}
                                  </option>
                                ))}
                              </BootstrapForm.Select>
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.state)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Citizenship *</BootstrapForm.Label>
                              <BootstrapForm.Select
                                name="citizenship"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.citizenship}
                                isInvalid={touched.citizenship && errors.citizenship}
                                required
                              >
                                <option value="">Select citizenship</option>
                                <option value="UAE">UAE Citizen</option>
                                <option value="Resident">UAE Resident</option>
                                <option value="Visitor">Visitor</option>
                              </BootstrapForm.Select>
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.citizenship)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>City *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="city"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.city}
                                placeholder="Enter city"
                                isInvalid={touched.city && errors.city}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.city)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          {/* Contact Information */}
                          <h6 className="mb-3 mt-4">Contact Information</h6>
                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={6}>
                              <BootstrapForm.Label>Phone Number *</BootstrapForm.Label>
                              <div className="d-flex gap-2">
                                <BootstrapForm.Select
                                  name="phone_country_code"
                                  onChange={handleChange}
                                  value={values.phone_country_code}
                                  style={{ maxWidth: '140px', minWidth: '140px' }}
                                  required
                                >
                                  {COUNTRY_CODES.map((country) => (
                                    <option key={country.code} value={country.code}>
                                      {country.flag} {country.code}
                                    </option>
                                  ))}
                                </BootstrapForm.Select>
                                <BootstrapForm.Control
                                  type="tel"
                                  name="phone_number"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.phone_number}
                                  placeholder="501234567"
                                  isInvalid={touched.phone_number && errors.phone_number}
                                  required
                                  style={{ flex: 1 }}
                                />
                              </div>
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.phone_number)}
                              </BootstrapForm.Control.Feedback>
                              <BootstrapForm.Text className="text-muted">
                                Select country code and enter phone number without country code
                              </BootstrapForm.Text>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={6}>
                              <BootstrapForm.Label>Permanent Address *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                as="textarea"
                                rows={2}
                                name="permanent_address"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.permanent_address}
                                placeholder="Enter complete permanent address"
                                isInvalid={touched.permanent_address && errors.permanent_address}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.permanent_address)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          {/* Medical Information */}
                          <h6 className="mb-3 mt-4">Medical Information</h6>
                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={12}>
                              <BootstrapForm.Label>Allergy *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                as="textarea"
                                rows={2}
                                name="allergy"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.allergy}
                                placeholder="Known allergies (enter 'None' if no known allergies)"
                                isInvalid={touched.allergy && errors.allergy}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.allergy)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={6}>
                              <BootstrapForm.Label>Primary Physician *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="primary_physician"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.primary_physician}
                                placeholder="Name of primary physician (letters, spaces, apostrophes, hyphens, dots only)"
                                isInvalid={touched.primary_physician && errors.primary_physician}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.primary_physician)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={6}>
                              <BootstrapForm.Label>Primary Physician License Number *</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="primary_physician_license"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.primary_physician_license}
                                placeholder="License number of primary physician"
                                isInvalid={touched.primary_physician_license && errors.primary_physician_license}
                                required
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.primary_physician_license)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Blood Group</BootstrapForm.Label>
                              <BootstrapForm.Select
                                name="blood_group"
                                onChange={handleChange}
                                value={values.blood_group}
                              >
                                <option value="unknown">Select Blood Group</option>
                                <option value="A+">A+</option>
                                <option value="A-">A-</option>
                                <option value="B+">B+</option>
                                <option value="B-">B-</option>
                                <option value="AB+">AB+</option>
                                <option value="AB-">AB-</option>
                                <option value="O+">O+</option>
                                <option value="O-">O-</option>
                              </BootstrapForm.Select>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Height (cm)</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="number"
                                name="height"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.height}
                                placeholder="e.g., 175"
                                min="30"
                                max="300"
                                isInvalid={touched.height && errors.height}
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.height)}
                              </BootstrapForm.Control.Feedback>
                              <BootstrapForm.Text className="text-muted">
                                Between 30-300 cm
                              </BootstrapForm.Text>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Weight (kg)</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="number"
                                name="weight"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.weight}
                                placeholder="e.g., 70"
                                min="1"
                                max="500"
                                isInvalid={touched.weight && errors.weight}
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.weight)}
                              </BootstrapForm.Control.Feedback>
                              <BootstrapForm.Text className="text-muted">
                                Between 1-500 kg
                              </BootstrapForm.Text>
                            </BootstrapForm.Group>
                          </Row>

                          {/* Emergency Contact */}
                          <h6 className="mb-3 mt-4">Emergency Contact</h6>
                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Emergency Contact Name</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="emergency_contact_name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.emergency_contact_name}
                                placeholder="Enter emergency contact name"
                                isInvalid={touched.emergency_contact_name && errors.emergency_contact_name}
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.emergency_contact_name)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Emergency Contact Phone</BootstrapForm.Label>
                              <div className="d-flex gap-2">
                                <BootstrapForm.Select
                                  name="emergency_contact_country_code"
                                  onChange={handleChange}
                                  value={values.emergency_contact_country_code}
                                  style={{ maxWidth: '120px', minWidth: '120px' }}
                                >
                                  {COUNTRY_CODES.map((country) => (
                                    <option key={country.code} value={country.code}>
                                      {country.flag} {country.code}
                                    </option>
                                  ))}
                                </BootstrapForm.Select>
                                <BootstrapForm.Control
                                  type="tel"
                                  name="emergency_contact_phone"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.emergency_contact_phone}
                                  placeholder="501234567"
                                  isInvalid={touched.emergency_contact_phone && errors.emergency_contact_phone}
                                  style={{ flex: 1 }}
                                />
                              </div>
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.emergency_contact_phone)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Relationship</BootstrapForm.Label>
                              <BootstrapForm.Select
                                name="emergency_contact_relationship"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.emergency_contact_relationship}
                                isInvalid={touched.emergency_contact_relationship && errors.emergency_contact_relationship}
                              >
                                <option value="">Select relationship</option>
                                {VALID_RELATIONSHIPS.map((relationship) => (
                                  <option key={relationship} value={relationship}>
                                    {relationship.charAt(0).toUpperCase() + relationship.slice(1)}
                                  </option>
                                ))}
                              </BootstrapForm.Select>
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.emergency_contact_relationship)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          {/* Identification */}
                          <h6 className="mb-3 mt-4">Identification</h6>
                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={6}>
                              <BootstrapForm.Label>Emirates ID</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="emirates_id"
                                onChange={(e) => {
                                  const formatted = formatEmiratesId(e.target.value);
                                  setFieldValue('emirates_id', formatted);
                                }}
                                onBlur={handleBlur}
                                value={values.emirates_id}
                                placeholder="Enter Emirates ID (784-xxxx-xxxx-xxx-x)"
                                isInvalid={touched.emirates_id && errors.emirates_id}
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.emirates_id)}
                              </BootstrapForm.Control.Feedback>
                              <BootstrapForm.Text className="text-muted">
                                Provide either Emirates ID or Passport Number
                              </BootstrapForm.Text>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={6}>
                              <BootstrapForm.Label>Passport Number</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="passport_number"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.passport_number}
                                placeholder="Enter passport number (AB1234567)"
                                isInvalid={touched.passport_number && errors.passport_number}
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.passport_number)}
                              </BootstrapForm.Control.Feedback>
                              <BootstrapForm.Text className="text-muted">
                                Provide either Emirates ID or Passport Number
                              </BootstrapForm.Text>
                            </BootstrapForm.Group>
                          </Row>

                          {/* Insurance Information */}
                          <h6 className="mb-3 mt-4">Insurance Information</h6>
                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Insurance Provider</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="insurance_provider"
                                onChange={handleChange}
                                value={values.insurance_provider}
                                placeholder="Insurance provider name (optional)"
                              />
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Policy Number</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="insurance_policy_number"
                                onChange={handleChange}
                                value={values.insurance_policy_number}
                                placeholder="Policy number (optional)"
                              />
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={4}>
                              <BootstrapForm.Label>Subscriber Name</BootstrapForm.Label>
                              <BootstrapForm.Control
                                type="text"
                                name="insurance_subscriber_name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.insurance_subscriber_name}
                                placeholder="Subscriber name (optional)"
                                isInvalid={touched.insurance_subscriber_name && errors.insurance_subscriber_name}
                              />
                              <BootstrapForm.Control.Feedback type="invalid">
                                {safeErrorRender(errors.insurance_subscriber_name)}
                              </BootstrapForm.Control.Feedback>
                            </BootstrapForm.Group>
                          </Row>

                          {/* Patient Classification */}
                          <h6 className="mb-3 mt-4">Patient Classification</h6>
                          <Row className="mb-3">
                            <BootstrapForm.Group as={Col} md={6}>
                              <BootstrapForm.Check
                                type="checkbox"
                                name="is_vip"
                                label="VIP Patient"
                                checked={values.is_vip}
                                onChange={handleChange}
                              />
                              <BootstrapForm.Text className="text-muted">
                                Mark this patient as VIP for priority treatment
                              </BootstrapForm.Text>
                            </BootstrapForm.Group>

                            <BootstrapForm.Group as={Col} md={6}>
                              <BootstrapForm.Check
                                type="checkbox"
                                name="is_tourist"
                                label="Tourist/Visitor"
                                checked={values.is_tourist}
                                onChange={handleChange}
                              />
                              <BootstrapForm.Text className="text-muted">
                                Mark this patient as a tourist or temporary visitor
                              </BootstrapForm.Text>
                            </BootstrapForm.Group>
                          </Row>

                          {/* Submit Button */}
                          <Row className="mb-4 mt-4">
                            <BootstrapForm.Group as={Col}>
                              {isLoading ? (
                                <button
                                  disabled
                                  className="btn btn-primary"
                                >
                                  Updating Patient...{" "}
                                  <img
                                    height="20"
                                    width="20px"
                                    src="assets/images/loading.gif"
                                    alt="Loading"
                                  />
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    position: 'relative',
                                    zIndex: 1000,
                                    pointerEvents: 'auto',
                                    cursor: 'pointer',
                                    opacity: 1,
                                    display: 'inline-block'
                                  }}
                                  data-testid="update-patient-submit"
                                >
                                  Update Patient
                                </button>
                              )}
                            </BootstrapForm.Group>
                          </Row>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default EditPatientCredentials;
